import {Customer} from "../Model/Customer";

/**
 * Transforms the inputs of the form into a customer object.
 */
export class CustomerToInputTransformer {

  from(formInput) {
    return new Customer()
      .setFirstName(formInput.first_name)
      .setLastName(formInput.last_name)
      .setEmail(formInput.email)
      .setPhoneNumber(formInput.phone_number)
      .setPostalCode(formInput.postal_code)
      .setSubscriptions(formInput.subscriptions)
      .setComment(formInput.additional_comments)
      .setPrivacyPolicy(formInput.privacy_policy === "1" ? true : false)
      .setSubscribed(formInput.subscribed_to_newsletter === "1" ? true : false)
  }

}
